export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const ADD_WAYPOINT = 'ADD_WAYPOINT'
export const SET_WAYPOINT = 'SET_WAYPOINT'
export const CLEAR_WAYPOINTS = 'CLEAR_WAYPOINTS'
export const UPDATE_TEXTINPUT = 'UPDATE_TEXTINPUT'
export const REQUEST_GEOCODE_RESULTS = 'REQUEST_GEOCODE_RESULTS'
export const RECEIVE_GEOCODE_RESULTS = 'RECEIVE_GEOCODE_RESULTS'
export const FETCH_GEOCODE = 'FETCH_GEOCODE'
export const MESSAGE_HANDLER = 'RESULT_HANDLER'
export const UPDATE_TEXTINPUT_ISO = 'UPDATE_TEXTINPUT_ISO'
export const REQUEST_GEOCODE_RESULTS_ISO = 'REQUEST_GEOCODE_RESULTS_ISO'
export const RECEIVE_GEOCODE_RESULTS_ISO = 'RECEIVE_GEOCODE_RESULTS_ISO'
export const UPDATE_SETTINGS_ISO = 'UPDATE_SETTINGS_ISO'
export const EMPTY_WAYPOINT = 'EMPTY_WAYPOINT'
export const CONSTRUCT_REQUEST = 'CONSTRUCT_REQUEST'
export const UPDATE_TAB = 'UPDATE_TAB'
export const LOADING = 'LOADING'
export const INSERT_WAYPOINT = 'INSERT_WAYPOINT'
export const RECEIVE_ROUTE_RESULTS = 'RECEIVE_ROUTE_RESULTS'
export const CLEAR_ROUTES = 'CLEAR_ROUTES'
export const TOGGLE_PROVIDER_ISO = 'TOGGLE_PROVIDER'
export const RECEIVE_ISOCHRONE_RESULTS = 'RECEIVE_ISOCHRONE_RESULTS'
export const CLEAR_ISOS = 'CLEAR_ISOS'
export const SHOW_SETTINGS = 'SHOW_SETTINGS'
export const TOGGLE_DIRECTIONS = 'TOGGLE_DIRECTIONS'
export const HIGHLIGHT_MNV = 'HIGHLIGHT_MNV'
export const ZOOM_TO_MNV = 'ZOOM_TO_MNV'
export const ZOOM_TO = 'ZOOM_TO'
export const RESET_SETTINGS = 'RESET_SETTINGS'
export const UPDATE_INCLINE_DECLINE = 'UPDATE_INCLINE_DECLINE'
export const UPDATE_DATETIME = 'UPDATE_DATETIME'
